<template>
    <el-dialog title="页面链接" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small">
          <el-form-item label="点击复制链接" :label-width="formLabelWidth">
            <el-button @click="submitFunc(1)" type="text" size="small">微信小程序</el-button>
            <el-button @click="submitFunc(2)" type="text" size="small">公众号，H5网页</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    export default {
        data() {
            return {
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
            };
        },
        props: ['is_open', 'dataModel'],
        created() {
          this.dialogVisible = this.is_open;
        },
        methods: {
            /*确认事件*/
            submitFunc(e) {
              var copyContent = document.createElement('input');     //创建一个隐藏input（重要！）
              if (e == 1) {
                copyContent.value = "pages/product/detail/detail?product_id=" + this.dataModel.product_id;    //拼接多个赋值
              }else{
                copyContent.value = window.location.protocol + '//' + window.location.host + "/h5/pages/product/detail/detail?product_id=" + this.dataModel.product_id + "&app_id=" + this.dataModel.app_id;    //拼接多个赋值
              }
              document.body.appendChild(copyContent);
              copyContent.select(); // 选择对象
              document.execCommand("Copy"); // 执行浏览器复制命令
              this.$message.success("复制成功！");
              copyContent.remove();
            },


            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('closeDialog', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/copy.vue